import { useMemo } from "react";
import { Colophon } from "../../types/colophon";
import { initMetadata } from "../../controllers/formController";
import { SystemEntityProofreadingStatus } from "../../shared/enums/shared-enums";
import useEvidenceLogic from "./evidenceLogic";
import useVersionRefLogic from "./versionRefLogic";

const useColophonLogic = () => {
  const { internalEvidenceTypeEnum, defaultNameInternalEvidence } =
    useEvidenceLogic();
  const { defaultVersionRef } = useVersionRefLogic();

  const userEnums = useMemo<string[]>(
    () => [internalEvidenceTypeEnum],
    [internalEvidenceTypeEnum]
  );

  const metadataFieldNames = useMemo<Array<keyof Colophon>>(
    () => ["colophon", "work", "author"],
    []
  );

  const defaultColophon = useMemo<Colophon>(() => {
    return {
      _id: "",
      _rev: "",
      _key: "",
      published_id: "",
      colophon: "",
      notes: "",
      virtually_identical_with: [],
      author: null,
      work: null,
      version: defaultVersionRef,
      internal_notes: "",
      entity_status_of_proofreading:
        SystemEntityProofreadingStatus.NOT_PROOFREAD,
      attributes_metadata: initMetadata<Colophon>(metadataFieldNames),
      name_internal_evidence: defaultNameInternalEvidence,
      author_id: null,
      work_id: "",
    };
  }, [defaultVersionRef, defaultNameInternalEvidence, metadataFieldNames]);

  const getDisplayName = (colophon?: Colophon | null): string =>
    `Colophon${colophon?.published_id ? `: ${colophon.published_id}` : ""}`;

  return {
    userEnums,
    metadataFieldNames,
    defaultColophon,
    getDisplayName,
  };
};

export default useColophonLogic;
